
import { Component, Mixins, Ref, Vue } from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import { MDB } from "@/plugins/uyap-plugin/MDB";
import { VForm } from "@/types";
import { TaskDurum } from "@/plugins/uyap-plugin/enum/TaskDurum";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import XmlController from "@/plugins/uyap-plugin/takip_ac/XmlController";
import { Task } from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import { TaskTuru } from "@/plugins/uyap-plugin/enum/TaskTuru";
import TakipHazirlaEvrakEkleForm from "@/components/eicrapro/TakipHazirlaEvrakEkleForm.vue";
import { FileEntity } from "@/entity/FileEntity";
import TarafInterface from "@/plugins/uyap-plugin/takip_ac/parser/TarafInterface";
import DayanakList from "@/components/eicrapro/DayanakList.vue";
import FormButton from "@/components/dialogs/FormButton.vue";
import { OdemeTipiEnum } from "@/plugins/uyap-plugin/takip_ac/OdemeTipleri";
import { DosyaFormDataInterface } from "@/plugins/uyap-plugin/takip_ac/DosyaFormDataInterface";
import { ProgramPaths } from "@/enum/ProgramPaths";
import MahiyetSecForm from "@/components/eicrapro/MahiyetSecForm.vue";
import { IcraTakipMahiyetleriCevapRow } from "@/plugins/uyap-plugin/uyap/IcraTakipMahiyetleri";
import TakipXmlParser from "@/plugins/uyap-plugin/takip_ac/TakipXmlParser";
import TakipHazirlaDayanakEkleForm from "@/components/eicrapro/TakipHazirlaDayanakEkleForm.vue";
import { AdliyelerCevap } from "@/plugins/uyap-plugin/uyap/Adliyeler";
import UyapIlamBilgileriForm from "@/components/eicrapro/UyapIlamBilgileriForm.vue";
import TakipAcVekaletEkleForm from "@/components/eicrapro/TakipAcVekaletEkleForm.vue";
import NewFormDialog from "@/components/dialogs/NewFormDialog.vue";
import { IbanTercihiEnum } from "@/plugins/uyap-plugin/uyap/IbanTercihiEnum";
import { IIban } from "@/plugins/uyap-plugin/uyap/AvukatKayitliIbanList";
import UyapTakipAc from "@/plugins/uyap-plugin/takip_ac/UyapTakipAc";
import { TakipAcStatusEnum } from "@/plugins/uyap-plugin/takip_ac/parser/TakipAcStatusEnum";
import Swal from "sweetalert2";
import YouTubeClickToLoad from "@/components/YouTubeClickToLoad.vue";
import TamamlanmayanTakipList from "@/components/eicrapro/TamamlanmayanTakipList.vue";
import TarafKisi from "@/plugins/uyap-plugin/takip_ac/parser/TarafKisi";
import TarafKurum from "@/plugins/uyap-plugin/takip_ac/parser/TarafKurum";

@Component({
  computed: {
    IbanTercihiEnum() {
      return IbanTercihiEnum;
    },
    OdemeTipiEnum() {
      return OdemeTipiEnum;
    },
    alacakliProblemVarMi() {
      try {
        return this.dosyalar && this.dosyalar.length > 0 && this.dosyalar.some(dosya => this.hasDeadAlacakli(dosya));
      } catch (e) {
        console.error('alacakliProblemVarMi hesaplarken hata:', e);
        return false;
      }
    },
    tarafHatalari() {
      const hatalar: string[] = [];

      this.dosyalar.forEach((dosya: any, dosyaIndex: number) => {
        // Alacaklı ölüm kaydı kontrolü
        const olusAlacaklilar = dosya.parsedFile.tarafList
            .filter((t: any) => t.tarafSifati.rolID === 21 && t.kisiMi && t.temelBilgileri?.olumKaydi === true);

        if (olusAlacaklilar.length > 0) {
          hatalar.push(`#${dosya.parsedFile.dosyaNo}: Alacaklı ölüm kaydı tespit edildi - Takip açılamaz`);
        }

        // Borçlu hataları
        const borclular = dosya.parsedFile.tarafList.filter((t: any) => t.tarafSifati.rolID !== 21);

        borclular.forEach((borclu: any) => {
          if (borclu.kisiMi && borclu.temelBilgileri?.olumKaydi === true) {
            hatalar.push(`#${dosya.parsedFile.dosyaNo}: Ölü borçlu - ${borclu.temelBilgileri.adi} ${borclu.temelBilgileri.soyadi}`);
          }

          if (borclu.kisiMi && borclu.temelBilgileri?.tcKimlikHatalimi === true) {
            hatalar.push(`#${dosya.parsedFile.dosyaNo}: Hatalı TC - ${borclu.temelBilgileri.adi} ${borclu.temelBilgileri.soyadi}`);
          }

          if (!borclu.kisiMi) {
            // Kurum için Mersis/Vergi no ve ünvan kontrolü
            const mersisBosMu = !borclu.temelBilgileri?.mersis || borclu.temelBilgileri.mersis.trim() === '';
            const vergiBosMu = !borclu.temelBilgileri?.vergiNo || borclu.temelBilgileri.vergiNo.trim() === '';
            const kurumAdiYok = !((borclu.temelBilgileri && borclu.temelBilgileri.kurumAdi) || borclu.kurumAdi);

            // Mersis VE Vergi VE Kurum ünvanı HEPSİ yoksa sorunlu
            if (mersisBosMu && vergiBosMu && kurumAdiYok) {
              const kurumAdi = borclu.adSoyad || borclu.kurumAdi || borclu.temelBilgileri?.kurumAdi || 'Bilinmeyen kurum';
              hatalar.push(`#${dosya.parsedFile.dosyaNo}: Bu bilgilerde Kurum bulunamadı - ${kurumAdi}`);
            }
          }
        });
      });

      return hatalar;
    }
  },
  components: {
    TamamlanmayanTakipList,
    NewFormDialog,
    TakipAcVekaletEkleForm,
    UyapIlamBilgileriForm,
    TakipHazirlaDayanakEkleForm,
    MahiyetSecForm,
    FormButton,
    DayanakList,
    TakipHazirlaEvrakEkleForm,
    FormDialog,
    Tutar,
    YouTubeClickToLoad
  }
})
export default class TakipHazirlaFormWizard extends Mixins(ObjectInputMixin) {
  @Ref('form') readonly form!: VForm;

  secilenDosyalar: Array<UyapTakipAc> = [];
  localValue: DosyaFormDataInterface = new DosyaFormDataInterface();
  activeStep: number = 1;
  onFly = false;
  parentTaskId = null;
  mdb = new MDB();
  takipHazirlaStatus = TakipHazirlaStatus;
  stepperHeaders = ['Takip Bilgileri', 'Takipler Hazırlanıyor', 'İşlemler Sıraya Alındı'];
  dosyalar: Array<UyapTakipAc> = [];
  tevziTipiDaireDisabled: boolean = true;
  tevziTipiGayrimenkulDisabled: boolean = true;
  durumObj = {
    1 : {
      icon: "mdi-clock-time-nine",
      label: "Sırada",
      color: "grey"
    },
    2 : {
      icon: "load",
      label: "İşleniyor",
      color: ""
    },
    3 : {
      icon: "mdi-alert",
      label: "Vekalet Yok",
      color: "orange"
    },
    4 : {
      icon: "mdi-progress-check",
      label: "Tamamlandı (İşlemlerde Sıraya Almaya Hazır)",
      color: "green"

    },
    5 : {
      icon: "mdi-check",
      label: "Tamamlandı",
      color: "green"
    }
  }
  headers = [
    {text: "#", value: "tempId", width: '20'},
    {text: "Alacaklı", value: "alacaklilar"},
    {text: "Borçlu", value: "borclular"},
    {text: "Borçlu Vekili", value: "vekil"},
    {text: "IBAN", value: "iban"},
    {text: "Takibe Esas Tutar", value: "toplamTakibeEsasMiktar", width: "175"},
    {text: "İşlemler", value: "actions", align: "center", width: "110"},
    {text: "Durum", value: "status", width: "80", align: "center"}
  ]
  isParsing = false;
  adliyeler: AdliyelerCevap = [];
  kotaKullanimSekliItems = [{text: 'Avukat', value: '0'}, {text: 'Kurum', value: '1'}]
  ibanTercihiItems = [
    {text: 'Avukat', value: 'Avukat'},
    {text: 'Müvekkil', value: 'Müvekkil'}
  ];
  durumAciklamasi = '';
  vekaletCache: Array<{ hash: string, data: FileEntity }> = [];
  mahiyetler: Array<{ mahiyetTuru: string, items: Array<IcraTakipMahiyetleriCevapRow> }> = [];
  mahiyetCheck = true;
  ilamCheck = true;
  vekaletCheck: Array<any> = [];
  avukatIbanlari: Array<IIban> = [];
  sorgulanmaDurumu = 0;
  isRunQuery= false;
  isDragOver = false;
  eksikSirketListesi: Array<{dosyaNo: string, tarafTipi: string, sorun: string, aciklama: string}> = [];

  detayListHeaders = [
    {icon: "mdi-account", title: "TCKN", key: "temelBilgileri.tcKimlikNo", show: "KISI"},
    {icon: "mdi-account", title: "Vergi No", key: "temelBilgileri.vergiNo", show: "KURUM"},
    {icon: "mdi-database-marker-outline", title: "Mernis/Mersis Adresi Kullan", key: "mernisAdresiKullan"},
    {icon: "mdi-map-marker-question-outline", title: "Mernis/Mersis Adresi Var Mı", key: "mernisAdresiVarMi"},
    {icon: "mdi-map", title: "İl/İlçe", key: ["adresBilgisi.ilAdi", "adresBilgisi.ilceAdi"]},
    {icon: "mdi-map-marker-outline", title: "Adres", key: "adresBilgisi.adres"},
  ]

  alacakKeys = [
    {key: "ilamliList", title: "İlamlı", aciklamaKey: ["dosyaNo","ilamliKurumAdi"], tarihKey: "ilamTarihi"},
    {key: "cekList", title: "Çek", aciklamaKey: "seriNumarasi", tarihKey: "kesideTarihi"},
    {key: "senetList", title: "Senet", aciklamaKey: "ilamsizTipi", tarihKey: "tanzimTarihi"},
    {key: "policeList", title: "Poliçe", aciklamaKey: "ilamsizTipi", tarihKey: "tanzimTarihi"},
    {key: "kontratList", title: "Kontrat", aciklamaKey: "tasinmazAdresiDetay", tarihKey: "hazirlanisTarihi"},
    {key: "digerList", title: "Diğer", aciklamaKey: "aciklama", tarihKey: "alacakTarihi"},
  ]

  alacakHeaders = [
    {text: "Tarih", value: "tarih"},
    {text: "Açıklama", value: "aciklama"},
    {text: "Tutar", value: "meblagi"},
    {text: "Para Birimi", value: "meblagTuruAciklama"},
  ]

  alacakKalemiHeaders = [
    {text: "Açıklama", value: "temelBilgileri.aciklama"},
    {text: "Tutar", value: "temelBilgileri.alacakTutari"},
    {text: "Para Birimi", value: "temelBilgileri.selectedParaBirimiAciklama"},
  ]

  mounted() {
    if (this.$route.query.icw) {
      this.localValue.xml = this.$store.state.xml;
      this.input();
    }
    window.addEventListener('dragover', this.handleDragEnter);
    this.$uyap.AvukatKayitliIbanList().run({}).then((ibanlar) => {
      this.avukatIbanlari = ibanlar.value;
      this.localValue.avukatIban = this.avukatIbanlari[0].ibanNumarasi;
    });
  }

  beforeDestroy() {
    window.removeEventListener('dragover', this.handleDragEnter);
  }

  handleDragEnter(event: any) {
    event.preventDefault();
    this.isDragOver = true;
  }

  handleFileDrop(event: any) {
    this.isDragOver = false
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length) {
      const file = droppedFiles[0];
      if (file.type === 'application/xml' ||
          file.type === 'text/xml' ||
          file.name.split('.').pop().toLowerCase() == 'xml') {
        this.localValue.xml = file;
        this.input();
      } else {
        // Geçersiz dosya türü için hata yönetimi (isteğe bağlı)
        this.$toast.warning('Lütfen bir XML dosyası yükleyin.');
      }
    }
  }

  async onIlChange() {
    if (this.localValue.il) {
      this.adliyeler = await this.$uyap.Adliyeler().run({ilKodu: this.localValue.il});
    } else
      this.adliyeler = [];
    this.input();
  }

  copy(key: string | Array<string>, taraf: any) {
    let text = (Array.isArray(key) ? key.map(k => this.$helper.getNestedValue(taraf, k)).join(' ') : this.$helper.getNestedValue(taraf, key));
    if (typeof text == "boolean")
      text = text ? "Evet" : "Hayır";
    this.$helper.clickCopyText(text);
  }

  getData(key: string | Array<string>, taraf: any): string {
    if (Array.isArray(key)) {
      return key.map(k => this.$helper.getNestedValue(taraf, k)).join(' ');
    } else {
      let text = this.$helper.getNestedValue(taraf, key);
      if (typeof text == "boolean")
        text = text ? "Evet" : "Hayır";
      return text;
    }
  }

  changeAdres(taraf: TarafInterface, adres: any, index: number) {
    taraf.adresBilgisi = adres;
    taraf.adresListPickedIndex = index;
    if (taraf.temelBilgileri.kisiKurumId) {
      this.dosyalar.forEach(dosya => dosya.parsedFile.tarafList.forEach(tarafItem => {
        if (tarafItem.temelBilgileri.kisiKurumId == taraf.temelBilgileri.kisiKurumId) {
          tarafItem.adresBilgisi = adres;
          tarafItem.adresListPickedIndex = index;
        }
      }));
    }
  }

  changeIban(taraf: any, iban: any, index: number) {
    taraf.hesapBilgisi = iban.hesapBilgisi;
    taraf.isVekilIban = (iban.kisi == "Avukat");
    taraf.selectedIbanIndex = index;
    if (taraf.temelBilgileri.kisiKurumId) {
      this.dosyalar.forEach(dosya => dosya.parsedFile.tarafList.forEach(tarafItem => {
        if (tarafItem.temelBilgileri.kisiKurumId == taraf.temelBilgileri.kisiKurumId) {
          taraf.hesapBilgisi = iban.hesapBilgisi;
          taraf.isVekilIban = (iban.kisi == "Avukat");
          taraf.selectedIbanIndex = index;
        }
      }));
    }
  }

  onAdliyeChange() {
    //@ts-ignore
    let adliye = this.adliyeler.find(x => x.adliyeBirimID == this.localValue.adliye);
    //@ts-ignore
    if (adliye.gayriMenkulIcraDairesiSayisi > 0) {
      this.tevziTipiGayrimenkulDisabled = false;
    } else {
      this.tevziTipiGayrimenkulDisabled = true;
    }
    //@ts-ignore
    if (adliye.bankaIcraDairesiSayisi > 0) {
      this.tevziTipiDaireDisabled = false;
    } else {
      this.tevziTipiDaireDisabled = true;
    }
    this.input();
  }

  fileRule(file: any) {
    if (file) {
      let uzanti = file.name.split('.').pop().toLowerCase();
      if (uzanti == "xml")
        return true;
      else
        return "Sadece xlm dosya yüklenebilir.";
    } else
      return 'Lütfen bu alanı doldurun.';
  }

  tumDosyalariSec() {
    if (this.secilenDosyalar.length == this.dosyalar.length) {
      this.secilenDosyalar = [];
    } else {
      this.secilenDosyalar = this.dosyalar;
    }
  }

  async nextStep() {
    if (this.activeStep == 1 && this.form.validate()) {
      try {
        this.activeStep++;
        this.isParsing = true;
        // @ts-ignore
        let xml = await XmlController.readXmlWithEncoded(this.localValue.xml);
        const parseResult = await XmlController.parse(xml, this.localValue);
        const parsedXml = parseResult.filter((p) => p.success).map((p) => p.data!);
        let dosya: TakipXmlParser;
        let sorgulanmisDosyalar = [];
        let sorgulananDosyaSayisi = 0;
        this.sorgulanmaDurumu=0;
        this.isRunQuery = true;
        for (dosya of parsedXml) {
          const index: number = parsedXml.indexOf(dosya);
          let takipAc = new UyapTakipAc();
          takipAc.parsedFile = dosya;

          // Dosyadaki tüm borçluları listele
          const borclular = dosya.tarafList.filter(taraf => taraf.tarafSifati.rolID != 21);
          console.log('=== DOSYA BORÇLULARI ===');
          console.log('Toplam borçlu sayısı:', borclular.length);
          borclular.forEach((borclu, idx) => {
            console.log(`${idx + 1}. Borçlu:`, {
              adi: borclu.temelBilgileri?.adi,
              soyadi: borclu.temelBilgileri?.soyadi,
              tcKimlikNo: borclu.temelBilgileri?.tcKimlikNo,
              olumKaydi: borclu.temelBilgileri?.olumKaydi
            });
          });
          console.log('========================');

          try {
            await takipAc.runQuery();
          }catch (er: any ) {
            takipAc.status = TakipHazirlaStatus.query_fail;
            takipAc.addMessage("error",er.message);
          }finally {
            // runQuery sonrasında borçluların final durumunu göster
            const finalBorclular = dosya.tarafList.filter(taraf => taraf.tarafSifati.rolID != 21);
            console.log('=== RUNQUERY SONRASI BORÇLULAR ===');
            finalBorclular.forEach((borclu, idx) => {
              console.log(`${idx + 1}. Borçlu (Final):`, {
                adi: borclu.temelBilgileri?.adi,
                soyadi: borclu.temelBilgileri?.soyadi,
                tcKimlikNo: borclu.temelBilgileri?.tcKimlikNo,
                olumKaydi: borclu.temelBilgileri?.olumKaydi,
                takipeDahilEt: borclu.takipeDahilEt
              });
            });
            console.log('===================================');

            // Taraf sayısı kontrolü - TC'si olan borçlular için
            const xmlBorclularWithTC = borclular.filter(b => b.temelBilgileri?.tcKimlikNo && b.temelBilgileri.tcKimlikNo !== '');
            const finalBorclularWithTC = finalBorclular.filter(b => b.temelBilgileri?.tcKimlikNo && b.temelBilgileri.tcKimlikNo !== '');

            if (xmlBorclularWithTC.length !== finalBorclularWithTC.length) {
              takipAc.status = TakipHazirlaStatus.query_fail;
              takipAc.addMessage("error", `Taraf ekleme işlemlerindeki hata sebebiyle takibiniz başlatılamaz. XML'de ${xmlBorclularWithTC.length} TC'li borçlu var, sorgu sonrası ${finalBorclularWithTC.length} borçlu kaldı.`);
              console.log('TARAF SAYISI HATASI:', {
                xmlTcliBorc: xmlBorclularWithTC.length,
                finalTcliBorc: finalBorclularWithTC.length
              });
            }

            sorgulananDosyaSayisi++;
            this.sorgulanmaDurumu = (100/parsedXml.length) * sorgulananDosyaSayisi;
            // @ts-ignore
            takipAc.status = TaskDurum.SIRADA;
            // @ts-ignore
            takipAc.tempId = index + 1;
            sorgulanmisDosyalar.push(takipAc);
          }

        }
        this.dosyalar = sorgulanmisDosyalar;

        this.secilenDosyalar = this.dosyalar.filter(dosya => dosya.status !== this.takipHazirlaStatus.query_fail);
        this.dosyalar.forEach((dosya) => {
          if (dosya.parsedFile.icraDosyaBilgileri.isMahiyet()) {
            let findMahiyet = this.mahiyetler.find(mahiyet => mahiyet.mahiyetTuru == dosya.parsedFile.icraDosyaBilgileri.mahiyetTuru);
            if (!findMahiyet)
              this.mahiyetler.push({
                mahiyetTuru: dosya.parsedFile.icraDosyaBilgileri.mahiyetTuru,
                items: dosya.parsedFile.icraDosyaBilgileri.takipMahiyetleri
              })
          }
        });
        console.log('dosyalar', this.dosyalar)
      } catch (e: any) {
        this.$toast.error(e.message);
      } finally {
        this.isParsing = false;
        this.isRunQuery = false;
        this.sorgulanmaDurumu = 0;
      }
    }
    this.focusStep(this.activeStep);
  }

  async takipHazirla(hizliAc: boolean) {

    if(hizliAc){
      try{
        await this.$helper.takipAcOnay();
      }catch (e: any) {
        this.$toast.error(e.message);
        return;
      }
    }

    // Şirket bilgisi eksik olan dosyaları kontrol et
    const eksikSirketBilgisi = [];
    for (const dosya of this.secilenDosyalar) {
      if (dosya.parsedFile && dosya.parsedFile.tarafList) {
        // Alacaklı şirket kontrolü
        const alacaklilar = dosya.parsedFile.tarafList.filter((taraf: any) => taraf.tarafSifati.rolID === 21);
        for (const alacakli of alacaklilar) {
          if (!alacakli.kisiMi && !((alacakli.temelBilgileri && alacakli.temelBilgileri.kurumAdi) || alacakli.kurumAdi)) {
            eksikSirketBilgisi.push(`Dosya #${dosya['tempId']}: Alacaklı şirket bilgisi bulunamadı`);
          }
        }

        // Borçlu şirket kontrolü
        const borclular = dosya.parsedFile.tarafList.filter((taraf: any) => taraf.tarafSifati.rolID !== 21);
        for (const borclu of borclular) {
          if (!borclu.kisiMi && !((borclu.temelBilgileri && borclu.temelBilgileri.kurumAdi) || borclu.kurumAdi)) {
            eksikSirketBilgisi.push(`Dosya #${dosya['tempId']}: Borçlu şirket bilgisi bulunamadı`);
          }
        }
      }
    }

    // Eğer eksik şirket bilgisi varsa, takip hazırlamayı durdur
    if (eksikSirketBilgisi.length > 0) {
      this.$toast.error(`Takip hazırlanamıyor:\n${eksikSirketBilgisi.join('\n')}\n\nLütfen şirket bilgilerini kontrol edip düzeltin.`);
      return;
    }

    this.onFly = true;
    let dosya: any;
    for (dosya of this.secilenDosyalar) {
      if (dosya.status != this.takipHazirlaStatus.tamamlandi_hazir &&
          dosya.status != this.takipHazirlaStatus.tamamlandi_bitti) {
        dosya.status = this.takipHazirlaStatus.isleniyor;
        if (dosya.parsedFile.vekalet && dosya.parsedFile.vekalet.data) {
          this.durumAciklamasi = '#' + dosya.tempId + ' dosyanın vekaleti kontrol ediliyor';
          let vekaletData = await this.vekaletKontrol(dosya);
          dosya.parsedFile.vekaletObject = vekaletData;
          delete dosya.parsedFile.vekalet;
          this.durumAciklamasi = '#' + dosya.tempId + ' dosya hazır';
        } else {
          this.durumAciklamasi = '#' + dosya.tempId + ' dosyanın vekaleti yok';
        }
        dosya.status = this.takipHazirlaStatus.tamamlandi_hazir;
      }
    }
    if (hizliAc)
      await this.createTaskHizliTakip();
    else
      await this.createTask();
    this.onFly = false;
  }

  async vekaletKontrol(dosya: any): Promise<FileEntity> {
    let vekaletData: FileEntity;
    let vekalet = dosya.parsedFile.vekalet.data;
    const Crypto = require('crypto');
    let hash = Crypto.createHash('sha1').update(vekalet).digest().toString('hex');
    let formData = new FormData();
    let vekaletBlob = this.$helper.base64toBlob(vekalet, dosya.parsedFile.vekalet.mimeType);
    let findCache = this.vekaletCache.find(cache => cache.hash == hash);
    if (!findCache) {
      formData.append('vekilList', JSON.stringify(dosya.parsedFile.vekilList));
      formData.append('tarafList', JSON.stringify(dosya.parsedFile.tarafList.filter((taraf: TarafInterface) => taraf.tarafSifati.rolID == 21)));
      formData.append('aciklama', dosya.parsedFile.vekalet.name);
      formData.append('name', dosya.parsedFile.vekalet.name);
      formData.append('file', vekaletBlob);
      formData.append('dokuman_turu_id', '1');
      formData.append('hash', hash);
      formData.append('mime_type', dosya.parsedFile.vekalet.mimeType);
      vekaletData = await this.$http.post('/api/v1/task/vekalet-senkron', formData);
      this.vekaletCache.push({hash: hash, data: vekaletData});
    } else {
      vekaletData = findCache.data;
    }
    return vekaletData;
  }

  // dosya kaydetme hatası düzeltilene kadar kaldırma
  waitThisLong(saniye: number) {
    return new Promise(resolve => setTimeout(resolve, saniye * 1000))
  }

  async createTask() {
    if (this.secilenDosyalar.length == 0) {
      this.$toast.warning('Hazırlanacak takipleri seçiniz.');
      return;
    }

    // Seçili dosyalarda en az bir alacakli seçili mi kontrol et
    const hasSelectedAlacakli = this.secilenDosyalar.some(dosya =>
        dosya.parsedFile.tarafList
            .filter(taraf => taraf.isAlacakli())
            .some(borclu => borclu.selected === true)
    );

    if (!hasSelectedAlacakli) {
      this.$toast.warning('En az bir alacaklı seçmelisiniz.');
      return;
    }

    // Seçili dosyalarda en az bir borçlu seçili mi kontrol et
    const hasSelectedBorclu = this.secilenDosyalar.some(dosya =>
        dosya.parsedFile.tarafList
            .filter(taraf => taraf.isBorclu()) // Borçlular
            .some(borclu => borclu.selected === true)
    );

    if (!hasSelectedBorclu) {
      this.$toast.warning('En az bir borçlu seçmelisiniz.');
      return;
    }

    // Şirket bilgileri eksik olan takipleri kontrol et
    const eksikSirketBilgisi = [];
    this.secilenDosyalar.forEach(dosya => {
      if (dosya.parsedFile && dosya.parsedFile.tarafList) {
        dosya.parsedFile.tarafList.forEach(taraf => {
          if (taraf && !taraf.kisiMi) { // Kurum/şirket ise
            const kurumAdi = (taraf.temelBilgileri && taraf.temelBilgileri.kurumAdi) || taraf.kurumAdi || '';
            if (kurumAdi.trim() === '' || kurumAdi.includes('KURUM BULUNAMADI')) {
              const tarafTipi = (taraf.tarafSifati && taraf.tarafSifati.rolID === 21) ? 'Alacaklı' : 'Borçlu';
              eksikSirketBilgisi.push(`${tarafTipi} şirket bilgisi eksik`);
            }
          }
        });
      }
    });

    if (eksikSirketBilgisi.length > 0) {
      console.log('Eksik şirket bilgileri:', eksikSirketBilgisi);
      this.$toast.error('Şirket bilgileri eksik olan takipler bulundu. Lütfen vergi/mersis no veya şirket ünvanını kontrol ediniz.');
      return;
    }

    this.mahiyetCheck = true;
    this.secilenDosyalar.forEach(dosya => {
      if (dosya.parsedFile.icraDosyaBilgileri.isMahiyet() && !dosya.parsedFile.icraDosyaBilgileri.mahiyetId)
        this.mahiyetCheck = false;
      if (dosya.parsedFile.isIlamli() && !dosya.parsedFile.ilamSorgusu.status)
        this.ilamCheck = false;
    });
    if (!this.mahiyetCheck || !this.mahiyetCheck)
      return;
    let tasks: Array<Task> = [];
    let hazirDosyalar = this.secilenDosyalar.filter((dosya: any) => dosya.status == this.takipHazirlaStatus.tamamlandi_hazir);
    for (let dosya of hazirDosyalar) {
      // Seçili borçluları filtrele
      this.filterSelectedBorclular(dosya);

      let dayanaklar = [];
      for (const dayanak of dosya.parsedFile.dayanaklar) {
        let formData = new FormData();
        let base64 = dayanak.data;
        const Crypto = require('crypto');
        let hash = Crypto.createHash('sha1').update(base64).digest().toString('hex');
        let blob = this.$helper.base64toBlob(base64, dayanak.mimeType);
        formData.append('aciklama', dayanak.name);
        formData.append('name', dayanak.name);
        formData.append('file', blob);
        formData.append('hash', hash);
        formData.append('dokuman_turu_id', "9");
        formData.append('mime_type', dayanak.mimeType);
        let dayanakResponse = await this.$http.post('/api/v1/file', formData);
        dayanaklar.push(dayanakResponse.data);
        // dosya kaydetme hatası düzeltilene kadar kaldırma
        await this.waitThisLong(1);
      }
      dosya.parsedFile.dayanaklar = [];
      dosya.parsedFile.dayanaklarObject = dayanaklar;

      // @ts-ignore
      dosya.xmlName = this.localValue.xml.name;
      let task: Task = new Task();
      task.parent_id = this.parentTaskId;
      task.task_type_id = TaskTuru.takip_hazirla;
      task.data = dosya
      tasks.push(task);
    }
    let response = await this.$store.dispatch('postTasks', tasks);
    if (response)
      this.parentTaskId = response.data.id;
    this.islemlereGit(this.parentTaskId);
    this.activeStep++;
  }

  async createTaskHizliTakip(){
    if (this.secilenDosyalar.length == 0) {
      this.$toast.warning('Hazırlanacak takipleri seçiniz.');
      return;
    }

    // Seçili dosyalarda en az bir alacakli seçili mi kontrol et
    const hasSelectedAlacakli = this.secilenDosyalar.some(dosya =>
        dosya.parsedFile.tarafList
            .filter(taraf => taraf.isAlacakli())
            .some(borclu => borclu.selected === true)
    );

    if (!hasSelectedAlacakli) {
      this.$toast.warning('En az bir alacaklı seçmelisiniz.');
      return;
    }

    // Seçili dosyalarda en az bir borçlu seçili mi kontrol et
    const hasSelectedBorclu = this.secilenDosyalar.some(dosya =>
        dosya.parsedFile.tarafList
            .filter(taraf => taraf.isBorclu()) // Borçlular
            .some(borclu => borclu.selected === true)
    );

    if (!hasSelectedBorclu) {
      this.$toast.warning('En az bir borçlu seçmelisiniz.');
      return;
    }

    // Şirket bilgileri eksik olan takipleri kontrol et
    const eksikSirketBilgisi = [];
    this.secilenDosyalar.forEach(dosya => {
      if (dosya.parsedFile && dosya.parsedFile.tarafList) {
        dosya.parsedFile.tarafList.forEach(taraf => {
          if (taraf && !taraf.kisiMi) { // Kurum/şirket ise
            const kurumAdi = (taraf.temelBilgileri && taraf.temelBilgileri.kurumAdi) || taraf.kurumAdi || '';
            if (kurumAdi.trim() === '' || kurumAdi.includes('KURUM BULUNAMADI')) {
              const tarafTipi = (taraf.tarafSifati && taraf.tarafSifati.rolID === 21) ? 'Alacaklı' : 'Borçlu';
              eksikSirketBilgisi.push(`${tarafTipi} şirket bilgisi eksik`);
            }
          }
        });
      }
    });

    if (eksikSirketBilgisi.length > 0) {
      console.log('Eksik şirket bilgileri:', eksikSirketBilgisi);
      this.$toast.error('Şirket bilgileri eksik olan takipler bulundu. Lütfen vergi/mersis no veya şirket ünvanını kontrol ediniz.');
      return;
    }

    this.mahiyetCheck = true;
    this.secilenDosyalar.forEach(dosya => {
      if (dosya.parsedFile.icraDosyaBilgileri.isMahiyet() && !dosya.parsedFile.icraDosyaBilgileri.mahiyetId)
        this.mahiyetCheck = false;
    });
    if (!this.mahiyetCheck)
      return;
    this.vekaletCheck = [];
    this.secilenDosyalar.forEach(dosya => {
      if (!dosya.parsedFile.vekaletObject?.id) {
        // @ts-ignore
        this.vekaletCheck.push(dosya.tempId);
        // @ts-ignore
        dosya.status = this.takipHazirlaStatus.vekalet_yok;
      }
    });
    if (this.vekaletCheck.length>0)
      return;
    let tasks: Array<Task> = [];
    let hazirDosyalar = this.secilenDosyalar.filter((dosya: any) => dosya.status == this.takipHazirlaStatus.tamamlandi_hazir);
    for (let dosya of hazirDosyalar) {
      // Seçili borçluları filtrele
      this.filterSelectedBorclular(dosya);

      let dayanaklarObject: Array<FileEntity> = [];
      for (const dayanak of dosya.parsedFile.dayanaklar) {
        let formData = new FormData();
        let base64 = dayanak.data;
        const Crypto = require('crypto');
        let hash = Crypto.createHash('sha1').update(base64).digest().toString('hex');
        let blob = this.$helper.base64toBlob(base64, dayanak.mimeType);
        formData.append('aciklama', dayanak.name);
        formData.append('name', dayanak.name);
        formData.append('file', blob);
        formData.append('hash', hash);
        formData.append('dokuman_turu_id', "9");
        formData.append('mime_type', dayanak.mimeType);
        let dayanakResponse = await this.$http.post('/api/v1/file', formData);
        dayanaklarObject.push(dayanakResponse.data);
        // dosya kaydetme hatası düzeltilene kadar kaldırma
        await this.waitThisLong(1);
      }
      dosya.parsedFile.dayanaklar = [];
      dosya.parsedFile.dayanaklarObject = dayanaklarObject;
      // @ts-ignore
      dosya.xmlName = this.localValue.xml.name;
      let task: Task = new Task();
      task.parent_id = this.parentTaskId;
      task.task_type_id = TaskTuru.hizli_takip_ac;
      task.data = dosya
      tasks.push(task);
    }
    let response = await this.$store.dispatch('postTasks', tasks);
    if (response)
      this.parentTaskId = response.data.id;
    this.islemlereGit(this.parentTaskId,true);
    this.activeStep++;
  }

  addAllVekalet(vekalet: any) {
    this.dosyalar.forEach((dosya: any) => {
      if (!dosya.parsedFile.vekalet)
        dosya.parsedFile.vekalet = vekalet;
    });
  }

  addAllDayanak(dayanaklar: Array<any>) {
    this.dosyalar.forEach((dosya: any) => {
      dayanaklar.forEach(dayanak => {
        dosya.parsedFile.dayanaklar.push(dayanak);
      });
    });
  }

  selectAllMahiyet(mahiyet: Array<{ mahiyetTuru: string, value: number }>) {
    this.dosyalar.forEach(dosya => {
      if (dosya.parsedFile.icraDosyaBilgileri.isMahiyet()) {
        dosya.parsedFile.icraDosyaBilgileri.mahiyetId = mahiyet.find(m => m.mahiyetTuru == dosya.parsedFile.icraDosyaBilgileri.mahiyetTuru)?.value ?? null;
      }
    })
  }

  previousStep() {
    if (this.activeStep > 1) {
      this.activeStep--;
    }
    this.focusStep(this.activeStep);
  }

  focusStep(step: any) {
    let activeHeader = (this.$refs['step' + step] as Vue[])[0].$el;
    let headers = this.$refs['headers'] as Element;
    let activeHeaderRight = activeHeader.getBoundingClientRect().right;
    let headersLeft = headers.getBoundingClientRect().left;
    let headersWidth = headers.getBoundingClientRect().width;
    let scrollPosition = (activeHeaderRight - headersLeft) - headersWidth;
    if (scrollPosition < 0) {
      scrollPosition = 0;
    }
    headers.scrollLeft += scrollPosition;
  }

  islemlereGit(parentId?: any,hizliMi:boolean=false) {
    if (parentId && this.$store.getters.getAutoPlay) {
      if (hizliMi)
        this.$router.push(ProgramPaths.eicrapro + '/takip-ac-detay/' + parentId);
      else
        this.$router.push(ProgramPaths.eicrapro + '/takip-hazirla-detay/' + parentId);
    }
    else
      this.$router.push(ProgramPaths.eicrapro + '/islemler');
  }

  ilamBilgisiTamMi(item: any): boolean {
    // İlam bilgisi varsa ve gerekli alanlar doluysa true döner
    if (!item.parsedFile.isIlamli()) return false;

    let ilam = item.parsedFile.getIlamBilgileri();
    if (!ilam) return false;

    // Temel ilam bilgileri dolu mu kontrol et
    return !!(ilam.birimId && ilam.dosyaYil && ilam.dosyaSira);
  }

  async tevziAl(hizliAc: boolean) {
    this.takipHazirla(hizliAc);
  }

  updateBorcluSelection(dosya: any, borclu: any) {
    // Checkbox değişikliği sonrası yapılacak işlemler buraya eklenebilir
    console.log('Borçlu seçimi güncellendi:', borclu.takipeDahilEt);
  }

  updateAlacakliSelection(dosya: any, alacakli: any) {
    // Alacaklı seçimi güncellendiğinde çağırılır
    console.log('updateAlacakliSelection:', {
      dosyaNo: dosya.id,
      alacakliAdi: this.getMaskedNameAlacakli(alacakli),
      takipeDahilEt: alacakli.takipeDahilEt,
      alacakli
    });
  }

  filterSelectedBorclular(dosya: any) {
    // Sadece seçili borçluları (takipeDahilEt: true) tut
    dosya.parsedFile.tarafList = dosya.parsedFile.tarafList.filter(taraf => {
      // Alacaklı ise her zaman tut
      if (taraf.tarafSifati.rolID == 21) {
        return true;
      }

      // Borçlu ise sadece seçili olanları tut
      return taraf.takipeDahilEt === true;
    });
  }

  // TC ile sorgulanan kişiler için maskelenmiş isim göster
  getMaskedName(borclu: any): string {
    // Debug: Ölü kayıt kontrolü
    if (borclu.temelBilgileri?.olumKaydi === true) {
      console.log('getMaskedName - Ölü borçlu tespit edildi:', {
        adi: borclu.temelBilgileri.adi,
        soyadi: borclu.temelBilgileri.soyadi,
        olumKaydi: borclu.temelBilgileri.olumKaydi,
        takipeDahilEt: borclu.takipeDahilEt
      });
    }

    if (borclu.kisiMi) {
      // Kişi ise
      if (borclu.temelBilgileri) {
        const adi = borclu.temelBilgileri.adi || '';
        const soyadi = borclu.temelBilgileri.soyadi || '';

        // TC ile sorgulandıysa (temelBilgileri.tcKimlikNo var) maskelenmiş göster
        if (borclu.temelBilgileri.tcKimlikNo && borclu.temelBilgileri.tcKimlikNo !== '') {
          const maskedAdi = adi.length > 2 ? adi.substring(0, 2) + '*'.repeat(adi.length - 2) : adi;
          const maskedSoyadi = soyadi.length > 2 ? soyadi.substring(0, 2) + '*'.repeat(soyadi.length - 2) : soyadi;
          return `${maskedAdi} ${maskedSoyadi}`;
        } else {
          // TC yoksa normal göster
          return `${adi} ${soyadi}`;
        }
      } else {
        // temelBilgileri yoksa XML'den gelen adSoyad'ı göster
        return borclu.adSoyad || '';
      }
    } else {
      // Kurum/şirket ise
      if (borclu.temelBilgileri && borclu.temelBilgileri.kurumAdi) {
        return borclu.temelBilgileri.kurumAdi;
      } else if (borclu.kurumAdi) {
        return borclu.kurumAdi;
      } else {
        // Kurum sorgulanamadıysa XML'den gelen bilgiyi göster
        return borclu.adSoyad || borclu.kurumAdi || '⚠️ Kurum bilgisi eksik';
      }
    }
  }

  getMaskedNameAlacakli(alacakli: any): string {
    if (alacakli.kisiMi) {
      // Kişi ise
      if (alacakli.temelBilgileri) {
        const adi = alacakli.temelBilgileri.adi || '';
        const soyadi = alacakli.temelBilgileri.soyadi || '';

        // TC ile sorgulandıysa (temelBilgileri.tcKimlikNo var) maskelenmiş göster
        if (alacakli.temelBilgileri.tcKimlikNo && alacakli.temelBilgileri.tcKimlikNo !== '') {
          const maskedAdi = adi.length > 2 ? adi.substring(0, 2) + '*'.repeat(adi.length - 2) : adi;
          const maskedSoyadi = soyadi.length > 2 ? soyadi.substring(0, 2) + '*'.repeat(soyadi.length - 2) : soyadi;
          return `${maskedAdi} ${maskedSoyadi}`.trim();
        } else {
          // TC yoksa tam adını göster
          return `${adi} ${soyadi}`.trim();
        }
      } else {
        // temelBilgileri yoksa XML'den gelen adSoyad'ı göster
        return alacakli.adSoyad || '';
      }
    } else {
      // Kurum/şirket ise
      if (alacakli.temelBilgileri && alacakli.temelBilgileri.kurumAdi) {
        return alacakli.temelBilgileri.kurumAdi;
      } else if (alacakli.kurumAdi) {
        return alacakli.kurumAdi;
      } else {
        return alacakli.adSoyad || 'Bilinmeyen kurum';
      }
    }
  }

  isTarafDisabled(taraf: TarafKisi | TarafKurum): boolean {
    if (this.onFly)
      return true;
    else
      return !taraf.takipeDahilEt;
  }

  onXmlFileHandle(xml: File){
    this.localValue.xml = xml;
    this.input();
  }

  // Tüm dosyalarda alacaklı sorunu var mı kontrolü
  hasAnyAlacakliProblem(): boolean {
    return this.dosyalar.some(dosya => this.hasDeadAlacakli(dosya));
  }

  // Dosyada sorunlu alacaklı var mı kontrolü (ölü, TC hatalı, kurum bulunamadı)
  hasDeadAlacakli(item: any): boolean {
    return item.parsedFile.tarafList
        .filter((taraf: any) => taraf.tarafSifati.rolID === 21) // Alacaklılar
        .some((alacakli: any) => {
          // Ölü alacaklı kontrolü
          if (alacakli.kisiMi && alacakli.temelBilgileri?.olumKaydi === true) {
            return true;
          }
          // TC hatalı alacaklı kontrolü
          if (alacakli.kisiMi && alacakli.temelBilgileri?.tcKimlikHatalimi === true) {
            return true;
          }
          // Kurum bulunamadı kontrolü
          if (!alacakli.kisiMi && !((alacakli.temelBilgileri && alacakli.temelBilgileri.kurumAdi) || alacakli.kurumAdi)) {
            return true;
          }
          return false;
        });
  }

  sifirla() {
    this.localValue = new DosyaFormDataInterface();
    this.input();
    this.activeStep = 1;
  }
}

enum TakipHazirlaStatus {
  sirada = 1,
  isleniyor,
  vekalet_yok,
  tamamlandi_hazir,
  tamamlandi_bitti,
  query_fail
}
